import { ListViewInfiniteChildProps } from '@app/core/list-view/ListViewInfinite';
import { EnrichedCompositionListItemDto } from '@app/modules/compose/composition.types';
import { useQueryParam } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useIntl } from 'react-intl';
import { CompositionCard } from '../composition-card/CompositionCard';
import { CompositionsGridSkeleton } from './CompositionsGridSkeleton';

export type CompositionsGridProps = ListViewInfiniteChildProps<EnrichedCompositionListItemDto>;

/**
 * Plain grid of composition cards (no date sections).
 */
export function CompositionsGrid({ data, isLoading = false }: CompositionsGridProps) {
  const { $t } = useIntl();

  const forceSkeleton = useQueryParam('skeleton');

  if (isLoading || forceSkeleton) {
    return <CompositionsGridSkeleton />;
  }

  if (!data.length) {
    return (
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {$t({
            id: 'common.noResults',
            defaultMessage: 'Sin resultados',
          })}
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {data.map((composition) => (
        <Grid size={{ xs: 12, sm: 6, md: 4, xl: 3 }} key={composition.id}>
          <CompositionCard composition={composition} />
        </Grid>
      ))}
    </Grid>
  );
}
